import { apiClient } from '../client';
import { InvitationValidationParams, InvitationValidationResponse } from '../../../contract/dtos';

export interface SendInvitationParams {
  tenant_id: number;
  email: string;
  user_group_ids_list: number[];
  branch_ids_list: number[];
  component_id: number;
}

export const invitationApi = {
  validateInvitation: async (params: InvitationValidationParams): Promise<InvitationValidationResponse> => {
    try {
      const response = await apiClient.get(
        `/account/invitation/validate/${params.token}`,
        {
          params: {
            component_id: params.component_id
          }
        }
      );

      // If response is 200, invitation is valid
      if (response.status === 200) {
        return {
          success: true,
          data: {
            invitationId: params.token,
            isValid: true,
            ...response.data
          }
        };
      }

      return {
        success: false,
      };
    } catch (error: any) {
      return {
        success: false,
      };
    }
  },

  sendInvitation: async (params: SendInvitationParams): Promise<any> => {
    const response = await apiClient.post('/account/invitation/send', {
      tenant_id: params.tenant_id,
      email: params.email,
      user_group_ids_list: params.user_group_ids_list,
      branch_ids_list: params.branch_ids_list,
    }, {
      params: {
        tenant_id: params.tenant_id,
        component_id: params.component_id
      }
    });
    return response.data;
  }
};
